export const GlobalFeatureNameSpaceNotary = {
  SIGNIN_SIGNOUT: 'SIGNIN_SIGNOUT',
  ADVANCED_SEARCH: 'ADVANCED_SEARCH',
  DYNAMIC_TABS: 'DYNAMIC_TABS',
  GROUPS: 'GROUPS',
  DATAZONES: 'DATAZONES',
  ASSETS: 'ASSETS',
  USERS: 'USERS'
}

export const CommonActionSubTypeNotary = {
  NOP: 'NOP',
  ADDED: 'ADDED',
  DELETED: 'DELETED',
  UPDATED: 'UPDATED',
  LISTED: 'LISTED',
  SELECTED: 'SELECTED'
}

export const ArtificialDetailPropertyNames = {
  DETACHED_DEPENDENCY1: 'detachedDependency1',
  DETACHED_DEPENDENCY1_INITIAL_VALUES: 'detachedDependency1_initial',
  DETACHED_DEPENDENCY2: 'detachedDependency2',
  DETACHED_DEPENDENCY2_INITIAL_VALUES: 'detachedDependency2_initial',
  DETACHED_DEPENDENCY3: 'detachedDependency3',
  DETACHED_DEPENDENCY3_INITIAL_VALUES: 'detachedDependency3_initial',
  DETACHED_DEPENDENCY4: 'detachedDependency4',
  DETACHED_DEPENDENCY4_INITIAL_VALUES: 'detachedDependency4_initial',
  DETACHED_DEPENDENCY5: 'detachedDependency5',
  DETACHED_DEPENDENCY5_INITIAL_VALUES: 'detachedDependency5_initial'
}

export const RootObjectTypes = {
  BUILDING: 'BUILDING',
  GROUP: 'GROUP',
  DATAZONE: 'DATAZONE',
  ACCOUNT: 'ACCOUNT',
  ASSET: 'ASSET',
  PARTY: 'PARTY',
  ENTITY: 'ENTITY',
  SERVICE: 'SERVICE',
  SKILLSET: 'SKILLSET'
}
